require('../../../src/config.js')
require('../components/deepsearch/deepsearch.css')
require('../components/loader/loader.css')
require('../../css/blockgrid.css')
require('../../css/search.css')
require('../../../node_modules/ng-tags-input/build/ng-tags-input.js')
require('script-loader!../../../node_modules/jquery.scrollto/jquery.scrollTo.min.js')
require('./search.service.js')
require('../components/deepsearch/deepsearch.js')
require('../components/loader/loader.js')
require('../../../src/js/filter-service.js')
require('../components/infinityscroll/infinite-scroll.js')
require('../../../node_modules/bootstrap-slider/dist/css/bootstrap-slider.min.css')
require('script-loader!../../../node_modules/bootstrap-slider/dist/bootstrap-slider.min.js')

angular.module('app')
    .filter('sanitize', ['$sce', function ($sce) {
      return function (htmlCode) {
        return $sce.trustAsHtml(htmlCode)
      }
    }])
    .filter('highlights', function () {
      return function (testo, keywords) {
        var regenerateText = testo
        keywords.forEach(function (e) {
          var regex = new RegExp(e.text, 'gi')
          regenerateText = regenerateText.replace(regex, '<span class="highlights">' + e.text.toUpperCase() + '</span>')
        })
        return regenerateText
      }
    })
    .config(function ($locationProvider) {
      $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
        rewriteLinks: false
      })
    })
    .config(function (tagsInputConfigProvider) {
      tagsInputConfigProvider
        .setActiveInterpolation('tagsInput', { placeholder: true })
    })
    .controller('SearchCtrl', function ($timeout, LINKS, SearchService, $location) {

      var vm = this
      var baseFiltri = []
      var body = angular.element('body')
      var filtriPan = angular.element('#filtri-panel')
      var SearchActions = angular.element('#searchActions')
      var headerHeight = angular.element('#masthead').innerHeight()
      var SearchActionsPh = angular.element('.searchActions-placeholder')
      this.template = 'grid.html'
      this.cronologia = {}
      this.querysearch = $location.search()
      this.load = false
      this.itemsPerPage = 20
      this.currentSort = 'no'
      this.allSorts = { 'rl' : {'score': { '$meta': 'textScore'}},
                          'az' : {'preferred_label.name':1, 'preferred_label':1},
                          'za' : {'preferred_label.name':-1, 'preferred_label':-1},
                          'no' : {'data.start':-1},
                          'on' : {'data.start':1}
                        }
      this.currentPage = this.querysearch.currentPage ? parseInt(this.querysearch.currentPage) : 0
      this.items = []
      this.filterMed = false
      this.filterEsp = false
      this.filtriSelezionati = SearchService.getFiltriSelezionati()
      this.allKeywords = SearchService.getKeywords()
      this.resultBar = true
      this.mediaEnable = true
      this.openFilter = false

      this.azzeraFiltri = function () {
        vm.filtriSelezionati = []
        callServer()
      }
      this.eliminaFiltro = function (index) {
        if (vm.filtriSelezionati[index].data && vm.filtriSelezionati[index].data.path.startsWith('/Media')) {
          this.filterMed = false
        } else if (vm.filtriSelezionati[index].data && vm.filtriSelezionati[index].data.path.startsWith('/In esposizione')) {
          this.filterEsp = false
        }
        vm.filtriSelezionati.splice(index, 1)
        callServer()
      }
      this.filterTipologia = function (elem) {
        return elem.data.name === 'tipologiaOggetti' ||
            elem.data.name === 'tipologiaEntita'
      }
      this.filterTipologia = function (elem) {
        return elem.data.name === 'tipologiaOggetti' ||
            elem.data.name === 'tipologiaEntita'
      }
      this.selezionaFiltro = function (child) {
        _.remove(vm.filtriSelezionati, function (o) {
          if (typeof o.data !== 'undefined')
            return o.data.id == child.data.id
        })
        vm.filtriSelezionati.push(child)
        callServer()
      }
      this.aggiornaKeyword = function (event) {
        callServer()
      }
      this.selezionaCronologia = function (cronologia) {
        _.remove(vm.filtriSelezionati, function (o) {
          return !!o.cronologia
        })
        vm.filtriSelezionati.push({
          'cronologia': vm.cronologia
        })
        vm.cronologia = {}
        callServer()
      }
      this.stampaCronologia = function (cronologia) {
        if (cronologia && cronologia.from) {
          var input = cronologia.from.getFullYear()
          var lastwo = (input % 100) + 10
          return input + '-' + ((lastwo === 100) ? input + 10 : lastwo)
        } else {
          return ''
        }
      }
      this.classeFiltri = function (child) {
        return {
          'glyphicon-chevron-right p-right-half' : child.children.length > 0,
          'glyphicon-chevron-down' : !child.collapse && child.children.length > 0,
          'glyphicon-minus p-right-half' : child.children.length === 0
        }
      }
      this.pageCount = function () {
        return Math.ceil(vm.totalItems / vm.itemsPerPage)
      }
      this.prevPage = function () {
        if (vm.currentPage > 0) {
          vm.currentPage--
          recuperaDati()
        }
      }
      this.nextPage = function () {
        if (vm.currentPage < vm.pageCount() - 1) {
          vm.currentPage++
          recuperaDati()
        }
      }
      this.cambiaOrdinamento = function () {
        recuperaDati()
      }
      this.comparatorStartWith = function (actual, expected) {
        return new RegExp('^\/' + expected).test(actual)
      }
        // var SearchActionsHeight = SearchActions.innerHeight()
        // SearchActions.affix({
        //   offset: {
        //     top: headerHeight
        //   }
        // })
        // SearchActions.on('affixed.bs.affix', function () {
        //   SearchActionsPh.css('height', SearchActionsHeight);
        //   filtriPan.css({
        //     'position' : 'fixed',
        //     'width' : '100%',
        //     'top' : SearchActionsHeight,
        //     'z-index': '99'
        //   });
        // });
        // SearchActions.on('affixed-top.bs.affix', function (){
        //   SearchActionsPh.css('height', 0);
        //   filtriPan.css({
        //     'position' : 'relative',
        //     'width' : '100%',
        //     'top' : 0
        //   });
        // });
      this.toggleFilter = function () {
        var wHeight = angular.element(window).innerHeight()
        var headerHeight = angular.element('#masthead').innerHeight()
        var deepsearchOff = SearchActions[0].getBoundingClientRect().top
        var deepsearchHeight = angular.element('#searchActions').innerHeight()
        var hfiltriPan = wHeight - (deepsearchOff + deepsearchHeight)
        vm.openFilter = !vm.openFilter
        vm.resultBar = true
        if (vm.openFilter) {
          body.css({
            'overflow' : 'hidden'
          })
          filtriPan.css({
            'height' : hfiltriPan + 'px',
            'overflow-y' : 'scroll'
          })
        } else {
          body.css({
            'overflow' : 'auto'
          })
        }
      }
      callServer(true)
        // private
      function callServer (resetPage) {
        vm.load = false
        vm.resultBar = true
        vm.filtriSelezionati = angular.copy(vm.filtriSelezionati)

        var filtrisel = vm.filtriSelezionati.length
        if (filtrisel != 0) {
          jQuery('.badge-filtri-attivi').text(filtrisel).show()
        } else {
          jQuery('.badge-filtri-attivi').text('').hide()
        }
        recuperaDati(!resetPage)
        recuperaFiltri()
      }
      function recuperaDati (resetPage) {
        vm.load = false
        if (resetPage) {
          vm.currentPage = 0
        }
        SearchService.recuperaDati(vm.allKeywords, vm.filtriSelezionati, vm.currentPage, vm.itemsPerPage, vm.allSorts[vm.currentSort]).then(function (result) {
          vm.totalItems = result.data.count
          if (resetPage) {
            vm.items = normalizeData(result.data.data)
          } else {
            vm.items.push(...normalizeData(result.data.data))
          }
          vm.representations = vm.items
                    .filter(function (elem) {
                      return elem.representations
                    })
                    .map(function (elem) {
                      var key = elem.representations[0].url.thumbnail
                      var value = elem.representations[0].url.mediumlarge
                      return { 'key': key, 'value': value }
                    })
                    .reduce(function (old, elem) {
                      old[elem.key] = elem.value
                      return old
                    }, {})

          for (var thumbnail in vm.representations) {
            var tmp = new Image()
            tmp.src = vm.representations[thumbnail]
            tmp.thumbnail = thumbnail
            tmp.onload = function () {
              jQuery('.item-image .item-image_bg[style*="' + this.thumbnail.replace(/\./g, '\\.') + '"]').css('background-image', 'url(' + this.src + ')')
            }
          }
          vm.load = true
        })
      }
      function recuperaFiltri () {
        SearchService.recuperaFiltri(vm.allKeywords, vm.filtriSelezionati, vm.currentPage).then(function (result) {
          var filtri = calculateFilters(result.data.data, '/', 1)
          vm.filtri = _.map(filtri, function (item) {
            var obj = _.find(baseFiltri, function (base) {
              return item.data.path == base.data.path
            })
            if (obj) {
              item.children = _.map(obj.children, function (base) {
                return _.extend(_.clone(base), _.find(item.children, function (item) {
                  return item.data.path == base.data.path
                }))
              })
            }
            if (item.data.path == '/Aggregazione archivistica' || item.data.path == '/Unità archivistica') {
              item = ordinaElenco(item)
            } else if (item.data.path == '/Superfondo di appartenenza') {
              item = ordinaFondi(item)
            } else {
              item = ordinaAlfabetico(item)
            }

            return item
          })
          vm.resultBar = false
        })
      }
      function calculateFilters (lista, value, i) {
        var elems = _.filter(lista, function (item) {
          if (item.data.path.indexOf('\\/') > 0) {
            let k = item.data.path.split('\\').length
            let j = i
            j += (k > 1) ? k - 1 : 0
            return _.startsWith(item.data.path, value) && _.size(_.split(item.data.path, '/')) == j + 1
          } else {
            return _.startsWith(item.data.path, value) && _.size(_.split(item.data.path, '/')) == i + 1
          }
        })
        return _.map(elems, function (item) {
          item.children = calculateFilters(lista, item.data.path, i + 1)
          return item
        })
      }
      function normalizeData (data) {
        return _.map(data, function (item) {
          if (typeof item.preferred_label.name === 'undefined') {
            item.preferred_label = {
              name: item.preferred_label
            }
          }
          item.table_url = LINKS[item.table]
          return item
        })
      }
      function ordinaElenco (elenco) {
        var orderedChild = []
        var filtriOrdinati = {
          '100' : 'Complesso archivistico',
          '101' : 'Superfondo',
          '102' : 'Fondo',
          '103' : 'Subfondo',
          '104' : 'Serie',
          '105' : 'Fascicolo',
          '106' : 'Sottofascicolo',
          '107' : 'Inserto'
        }
        for (var i in filtriOrdinati) {
          var trovato = false
          for (var key in elenco.children) {
            if (filtriOrdinati[i] == elenco.children[key].data.name) {
              orderedChild[i] = elenco.children[key]
              delete elenco.children[key]
            }
          }
        }
        if (elenco != null) {
          elenco.children = _.compact(_.union(orderedChild, elenco.children))
        }
        return elenco
      }
      function ordinaFondi (elenco) {
        var orderedChild = []
        var filtriOrdinati = {
          '100' : 'I - Antica Compagnia di San Paolo e aggregati',
          '101' : 'II - Istituto di San Paolo Torino e aggregati',
          '102' : "III - Gestioni Egeli - Ente di Gestione e Liquidazione Immobiliare dell'Istituto di San Paolo di Torino",
          '103' : "IV - Segreteria generale dell'Istituto Bancario San Paolo di Torino e aggregato",
          '104' : 'Istituto Bancario San Paolo di Torino – Ufficio banche corrispondenti',
          '105' : 'Monografie artistiche - Fondo fotografico',
          '106' : 'Fondo Giuseppe e Bartolomeo Gallo',
          '107' : 'Fondo Dragone',
          '107' : 'Biblioteca',
          '108' : 'Biblioteca Credito agrario'
        }
        for (var i in filtriOrdinati) {
          var trovato = false
          for (var key in elenco.children) {
            if (filtriOrdinati[i] == elenco.children[key].data.name) {
              orderedChild[i] = elenco.children[key]
              delete elenco.children[key]
            }
          }
        }
        if (elenco != null) {
          elenco.children = _.compact(orderedChild)
        }
        return elenco
      }
      function ordinaAlfabetico (elenco) {
        elenco.children = elenco.children.filter((e) => e.data.name && !(e.data.name instanceof Array)).sort(function (a, b) {
          return a.data.name.toLowerCase().localeCompare(b.data.name.toLowerCase())
        })
        return elenco
      }

      Promise.all([
        SearchService.getFirstDate(vm.allKeywords, vm.filtriSelezionati, vm.currentPage),
        SearchService.getLastDate(vm.allKeywords, vm.filtriSelezionati, vm.currentPage)
      ]).then(values => {
        if (!values[0].data.data[0] && values[1].data.data[0]) {
          values[0].data.data[0] = values[1].data.data[0]
        } else if (values[0].data.data[0] && !values[1].data.data[0]) {
          values[1].data.data[0] = values[0].data.data[0]
        } else if (!values[0].data.data[0] && !values[1].data.data[0]) {
          return false
        }

        vm.firstDate = new Date(values[0].data.data[0].data_filtro.start.$date.$numberLong * 1).getFullYear()
        vm.lastDate = new Date(values[1].data.data[0].data_filtro.end.$date.$numberLong * 1).getFullYear()

        let tmpFirst = vm.firstDate
        if (vm.cronologia.from) {
          tmpFirst = vm.cronologia.from.getFullYear()
        }

        let tmpLast = vm.lastDate
        if (vm.cronologia.to) {
          tmpLast = vm.cronologia.to.getFullYear()
        }

        // Range Slider
        if (vm.slider) {
          vm.slider.destroy()
        }
        $timeout(() => {
          vm.slider = new Slider('#ex2', {
            tooltip: 'always',
            tooltip_split: true,
            range: true,
            min: vm.firstDate,
            max: vm.lastDate,
            step: 1,
            value: [tmpFirst, tmpLast]
          })

          vm.slider.on('slideStop', function (e) {
            let from = new Date(`01-01-${e[0]}`)
            let to = new Date(`12-31-${e[1]}`)

            if (vm.cronologia.from === from && vm.cronologia.to === to) {
              return
            }

            vm.cronologia = {
              from: from,
              to: to
            }

            vm.selezionaCronologia(vm.cronologia)
          })
        }, 0)
        return false
      })
    })



// WEBPACK FOOTER //
// ./src/js/pages/search.js